const actions = {
    FETCH_QUARTER : 'FETCH_QUARTER',
    FETCH_QUARTER_ATTENDANCE : 'FETCH_QUARTER_ATTENDANCE',

    fetchQuarterAction: (data) => {
        return {
            type: actions.FETCH_QUARTER,
            data: data
        };
    },
    fetchQuarterAttendanceAction: (data) => {
        return {
            type: actions.FETCH_QUARTER_ATTENDANCE,
            data: data
        };
    },
}

export default actions;
